// extracted by mini-css-extract-plugin
export const container = "gallery-module--container--2vuE0";
export const card = "gallery-module--card--2Z3eG";
export const cardImg = "gallery-module--cardImg--DGIY5";